export const errorMessages = Object.freeze({
  message: {
    TABLEAU_ERROR_MESSAGE_1: 'Something went wrong',
    TABLEAU_ERROR_MESSAGE_2:
      'Integrated dashboard registration failed. Please submit a support request.',
  },
})
